import {
  DynamicFormField,
  FormFieldsCustomizer,
  input,
  insertFieldAfter,
  select,
  updateFieldProps,
} from '@kinet-open-network/client/core/forms/ui';
import { DeliveryGeneralTabComponent } from '@kinet-open-network/client/deliveries/feature/detail';

export const deliveryFieldsCustomizer: FormFieldsCustomizer<
  DeliveryGeneralTabComponent
> = (fields, context) => {
  const fieldGroupFields = fields[0]?.fieldGroup;
  context.usersPickerStore.load();

  if (!fieldGroupFields) {
    return fields;
  }

  updateFieldProps(fieldGroupFields, 'deliveryModeId', {
    change: (field: DynamicFormField, event: { value?: string }) => {
      const deliveryModeId = event?.value;
      if (!deliveryModeId) return;

      context.deliveryModesService
        .findOne(deliveryModeId)
        .subscribe((deliveryMode) => {
          field.parent?.formControl?.patchValue({
            carLicensePlate: deliveryMode.name,
          });
        });
    },
  });

  insertFieldAfter(fieldGroupFields, 'state', [
    input('carLicensePlate', 'ŠPZ auta').props({ maxLength: 50 }).required(),
    input('trailerLicensePlate', 'ŠPZ prívesu')
      .props({ maxLength: 50 })
      .nullIfEmpty(),
    select('driverName', 'Meno vodiča')
      .props({ maxLength: 50 })
      .required()
      .options(context.userNamesOptions$)
      .props({
        editable: true,
      }),
  ]);

  return fields;
};
